<template>
  <div class="header-container">
    <div
      class="menu01-box"
      v-show="$store.state.isFateNav"
      @mouseout="moveNav()"
      @mouseover="removeNav()"
    >
      <ul class="main header-menu menu01">
        <li>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/digitIndex')"
              to="/digitIndex"
              target="_blank"
              >首页</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/mes')"
              to="/mes"
              target="_blank"
              >MES</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/erp')"
              to="/erp"
              target="_blank"
              >ERP</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/aps')"
              to="/aps"
              target="_blank"
              >APS</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/wms')"
              to="/wms"
              target="_blank"
              >WMS</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/acquisition')"
              to="/acquisition"
              target="_blank"
              >数据采集</router-link
            >
          </div>
        </li>
        <li>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/bidata')"
              to="/bidata"
              target="_blank"
              >BI数据可视化</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/qms')"
              to="/qms"
              target="_blank"
              >QMS</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/device')"
              to="/device"
              target="_blank"
              >设备管理</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/var')"
              to="/var"
              target="_blank"
              >工业VR/AR</router-link
            >
          </div>

          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/visua')"
              to="/visua"
              target="_blank"
              >3D可视化</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/remote')"
              to="/remote"
              target="_blank"
              >远程运维</router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //移入显示导航栏
    moveNav() {
      this.$store.commit("SET_ISFATENAV", false);
    },
    removeNav() {
      this.$store.commit("SET_ISFATENAV", true);
    },
    //点击顶部导航跳转对应的
    toNav(path) {
      sessionStorage.setItem("navIndex", JSON.stringify(2));
      //this.$store.commit("SET_NAVALLINDEX", 2);
      /*
      var routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
      */
    },
  },
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
